import { fetchAbsences, fetchUserAbsences } from '../../services/absences';
import { setLeaveBalance } from '../../services/profiles';
import { notify } from '../../store/feedback';
import { fetchAllPaginated } from '../../utils/supabaseQuery';

export default function absencesLoadingHandlers(deps, api) {
  const { profile, session, setAbsencesByDev, setAbsencesByDevAll, setUserAbsences, update } = deps;

  async function loadUserAbsences() {
    const { data } = await fetchUserAbsences(session);
    setUserAbsences(data || []);
  }

  // Charge toutes les absences (équipe pour le manager, les siennes sinon) dans deux maps
  // dev_id -> [absences] : absencesByDev (acceptées seulement — c'est elle qui bloque la capacité
  // dans la timeline et les affectations, une demande en attente ne doit rien bloquer avant d'être
  // validée) et absencesByDevAll (toutes, pour l'affichage des puces dans Équipe).
  async function loadAbsences() {
    let q = fetchAbsences();
    if (profile?.role !== 'manager') q = q.eq('user_id', session.user.id);
    const data = await fetchAllPaginated(q);
    const map = {},
      mapAll = {};
    for (const a of data || []) {
      (mapAll[a.dev_id] ||= []).push(a);
      if (a.statut === 'acceptee') (map[a.dev_id] ||= []).push(a);
    }
    setAbsencesByDev(map);
    setAbsencesByDevAll(mapAll);
  }

  // Solde de congés payés : correction manuelle par un manager (protégée du self-update par
  // profiles_protect_self_update_trg), tracée en base dans le journal (migration 020).
  async function saveLeaveBalance(devId, value) {
    const n = parseFloat(value);
    if (Number.isNaN(n)) return;
    const { error } = await setLeaveBalance(devId, n);
    if (error) {
      notify('Erreur enregistrement du solde : ' + error.message);
      return;
    }
    update((s) => ({ ...s, devs: s.devs.map((d) => (d.id === devId ? { ...d, soldeCp: n } : d)) }));
    await api.refreshLeaveBalances();
  }

  return { loadUserAbsences, loadAbsences, saveLeaveBalance };
}
